import { render, staticRenderFns } from "./DeleteIcon.vue?vue&type=template&id=531895a6&scoped=true&"
import script from "./DeleteIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DeleteIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531895a6",
  null
  
)

export default component.exports